module.exports = __webpack_public_path__ + "9b19c5e9467049c3cc4f0c0f532b9899.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/outfit-pirate.png
// module id = 1348
// module chunks = 0